import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSignal } from "@preact/signals";
import ChartTooltipAction from "../../ChartTooltipAction";
import ModalNote from "../../ModalNote";
import { msToSeconds } from "../../../lib/number";
import { trimSeconds } from "../../../lib/date";
export default function AddNoteAction(props) {
    const { point } = props;
    const modalOpen = useSignal(false);
    const onClickAddNote = (e) => {
        modalOpen.value = true;
        e.preventDefault();
    };
    const onCloseModal = () => {
        modalOpen.value = false;
    };
    return (_jsxs(_Fragment, { children: [_jsx(ChartTooltipAction, { icon: "pencil", children: _jsx("a", { href: "", onClick: onClickAddNote, children: "Add Note" }) }), _jsx(ModalNote, { isOpen: modalOpen.value, onClose: onCloseModal, timestamp: trimSeconds(msToSeconds(point.x)) })] }));
}
